import React, { useEffect, useRef } from "react";
import { gsap, Expo } from "gsap";
import CustomAnchor from "./CustomAnchor";
import useMediaQuery from "../../../hooks/useMediaQuery";

const MOBILE_BREAKPOINT = "(max-width: 960px)";

const Sidebar = ({
  name,
  title,
  anchorItems,
  currentSelection,
  setCurrentSection,
  onAnchorChange,
  isVisible,
}) => {

  const sidebarRef = useRef(null);
  const nameRef = useRef(null);
  const isMobileView = useMediaQuery(MOBILE_BREAKPOINT);

  useEffect(() => {
    if (!nameRef.current || !name || isMobileView) return;
    
    const el = nameRef.current;
    el.innerHTML = name.replace(/\S/g, "<span class='letter'>$&</span>");
    
    gsap.fromTo(
      ".name .letter",
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: "expo.out",
        duration: 1.5,
        stagger: 0.06,
        delay: 1.5,
      }
    );
  
  }, [name, isMobileView]);

  useEffect(() => {
    
    if (isMobileView) return;

    if (isVisible) {
      gsap.to(sidebarRef.current, {
        x: "0%",
        ease: Expo.easeInOut,
        duration: 1.2,
        delay: 1.0,
      });
    } else {
      
    }
  }, [isVisible, isMobileView]);
  
  
  return (
    <div className="sidebar" ref={sidebarRef}>
      {" "}
      <div>
        {" "}
        <div className="name" ref={nameRef}>
          {isMobileView ? name : ""}
        </div>{" "}
        <div className="title">{title}</div>{" "}
        <CustomAnchor
          currentSelection={currentSelection}
          setCurrentSelection={setCurrentSection}
          onChange={onAnchorChange}
          items={anchorItems}
        />{" "}
      </div>{" "}
    </div>
  );
};


export default Sidebar;
